
export const ADD_LAWFIRM_STARTED = "ADD_LAWFIRM_STARTED";
export const ADD_LAWFIRM_SUCESS = "ADD_LAWFIRM_SUCESS";
export const ADD_LAWFIRM_FAILED = "ADD_LAWFIRM_FAILED";

export const GET_LAWFIRM_STARTED = "GET_LAWFIRM_STARTED";
export const GET_LAWFIRM_SUCESS = "GET_LAWFIRM_SUCESS";
export const GET_LAWFIRM_FAILED = "GET_LAWFIRM_FAILED";

export const GET_ALLLAWFIRM_STARTED = "GET_ALLLAWFIRM_STARTED";
export const GET_ALLLAWFIRM_SUCESS = "GET_ALLLAWFIRM_SUCESS";
export const GET_ALLLAWFIRM_FAILED = "GET_ALLLAWFIRM_FAILED";
 

export const UPDATE_LAWFIRM_STARTED = "UPDATE_LAWFIRM_STARTED";
export const UPDATE_LAWFIRM_SUCESS = "UPDATE_LAWFIRM_SUCESS";
export const UPDATE_LAWFIRM_FAILED = "UPDATE_LAWFIRM_FAILED";


export const ADD_ATTORNEY_STARTED = "ADD_ATTORNEY_STARTED";
export const ADD_ATTORNEY_SUCESS = "ADD_ATTORNEY_SUCESS";
export const ADD_ATTORNEY_FAILED = "ADD_ATTORNEY_FAILED";

export const GET_ATTORNEY_STARTED = "GET_ATTORNEY_STARTED";
export const GET_ATTORNEY_SUCESS = "GET_ATTORNEY_SUCESS";
export const GET_ATTORNEY_FAILED = "GET_ATTORNEY_FAILED";

export const UPDATE_ATTORNEY_STARTED = "UPDATE_ATTORNEY_STARTED";
export const UPDATE_ATTORNEY_SUCESS = "UPDATE_ATTORNEY_SUCESS";
export const UPDATE_ATTORNEY_FAILED = "UPDATE_ATTORNEY_FAILED";

export const UPDATE_LF_CORPORATE_STARTED = "UPDATE_LF_CORPORATE_STARTED";
export const UPDATE_LF_CORPORATE_SUCESS = "UPDATE_LF_CORPORATE_SUCESS";
export const UPDATE_LF_CORPORATE_FAILED = "UPDATE_LF_CORPORATE_FAILED";

export const GET_LF_CORPORATE_STARTED = "GET_LF_CORPORATE_STARTED";
export const GET_LF_CORPORATE_SUCESS = "GET_LF_CORPORATE_SUCESS";
export const GET_LF_CORPORATE_FAILED = "GET_LF_CORPORATE_FAILED";

export const ADD_LF_CORPORATE_STARTED = "ADD_LF_CORPORATE_STARTED";
export const ADD_LF_CORPORATE_SUCESS = "ADD_LF_CORPORATE_SUCESS";
export const ADD_LF_CORPORATE_FAILED = "ADD_LF_CORPORATE_FAILED";

export const GET_LAWFIRMCASEFLOW_STARTED = "GET_LAWFIRMCASEFLOW_STARTED";
export const GET_LAWFIRMCASEFLOW_SUCESS = "GET_LAWFIRMCASEFLOW_SUCESS";
export const GET_LAWFIRMCASEFLOW_FAILED = "GET_LAWFIRMCASEFLOW_FAILED";
 
export interface IAddCorporates {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    MODEMInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}
 
 export const addLawFirmDetails = (LawFirmDetailsInput: any) => {
  
    return {
        type: ADD_LAWFIRM_STARTED,
        payload: 'status',
        input: LawFirmDetailsInput
    };
};
 
export const updateLawFirmDetails = (LawFirmDetailsInput: any) => {
  
    return {
        type: UPDATE_LAWFIRM_STARTED,
        payload: 'status',
        input: LawFirmDetailsInput
    };
};
export const getAllLawFirmDetails = (companyId) => {
    // alert("newid");
     return {
         type: GET_LAWFIRM_STARTED ,
         payload: 'Value',
         input:companyId
     };
 };

 export const addAttorneyDetails = (AttorneyDetailsInput: any) => {
  
    return {
        type: ADD_ATTORNEY_STARTED,
        payload: 'status',
        input: AttorneyDetailsInput
    };
};
 
export const updateAttorneyDetails = (AttorneyDetailsInput: any) => {
  
    return {
        type: UPDATE_ATTORNEY_STARTED,
        payload: 'status',
        input: AttorneyDetailsInput
    };
};
export const getAllAttorneyDetails = (companyId) => {
    // alert("newid");
     return {
         type: GET_ATTORNEY_STARTED ,
         payload: 'Value',
         input:companyId
     };
    };
     export const addCorporateDetails = (CorporateDetailsInput: any) => {
  alert("lawfirm-actions");
        return {
            type: ADD_LF_CORPORATE_STARTED,
            payload: 'status',
            input: CorporateDetailsInput 
        };
    };
     
    export const updateCorporateDetails = (CorporateDetailsInput: any) => {
      
        return {
            type: UPDATE_LF_CORPORATE_STARTED,
            payload: 'status',
            input: CorporateDetailsInput
        };
    };
    export const getAllCorporateDetails = (companyId) => {
        // alert("newid");
         return {
             type: GET_LF_CORPORATE_STARTED ,
             payload: 'Value',
             input:companyId
         };
        };

        export const getAllCaseflowsByLawfirmId = (lawfirmId) => {
            // alert("newid");
             return {
                 type: GET_LAWFIRMCASEFLOW_STARTED ,
                 payload: 'Value',
                 input:lawfirmId 
             };
         };

         export const getAllLawFirmDetail = () => {
            // alert("newid");
             return {
                 type: GET_ALLLAWFIRM_STARTED ,
                 payload: 'Value',
                
             };
         };
        